import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { user2faUrl, userProfileUrl } from 'common/config/urls';
import { TWO_FACTOR_AUTH_TAB } from 'common/constants/user';
import { ACCOUNT_SETTINGS_SLUG } from 'dashboard409a/common/constants';

const useAccountSettingsNavItems = () => {
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();

  return useMemo(
    () =>
      firmSlugParam
        ? [
          { label: 'Settings', value: ACCOUNT_SETTINGS_SLUG, to: userProfileUrl(firmSlugParam) },
          { label: 'Two-Factor Authentication', value: TWO_FACTOR_AUTH_TAB, to: user2faUrl(firmSlugParam) },
        ]
        : [],
    [firmSlugParam]
  );
};

export default useAccountSettingsNavItems;
